import { Action } from '@ngrx/store';
import { IFilteredResponse } from '../../../core/services/api/filtered-response.interface';
import { Job } from '../../../vas/business-objects/job/job.model';
import { JobListPageItemModel } from './job-list-page-item.model';
import { JobListPageMode } from './job-list-page.types';

export const CACHE_TO_PAGE = '[JobListPage] Cache to Page';
export const CACHE_TO_PAGE_SUCCESS = '[JobListPage] Cache to Page Success';
export const INITIALISE = '[JobListPage] Initialise';
export const SET_MODE = '[JobListPage] Set Mode';
export const SET_SEARCH_TERM = '[JobListPage] Set Search Term';
export const SET_SEARCH_TERM_SUCCESS = '[JobListPage] Set Search Term Success';
export const SET_SEARCH_TERM_FAIL = '[JobListPage] Set Search Term Fail';

export class InitialiseAction implements Action {
    readonly type = INITIALISE;

    constructor(public payload: {accountId: string}) {

    }
}

export class CacheToPageAction implements Action {
    readonly type = CACHE_TO_PAGE;
}

export class CacheToPageSuccessAction implements Action {
    readonly type = CACHE_TO_PAGE_SUCCESS;

    constructor(public payload: {jobs: Array<JobListPageItemModel>}) {

    }
}

export class SetMode implements Action {
    readonly type = SET_MODE;

    constructor(public payload: {mode: JobListPageMode}) {
    }
}

export class SetSearchTermAction implements Action {
    readonly type = SET_SEARCH_TERM;

    constructor(public payload: {
        accountId: string,
        searchTerm: string
    }) {
    }
}

export class SetSearchTermSuccessAction implements Action {
    readonly type = SET_SEARCH_TERM_SUCCESS;

    constructor(public payload: {response: IFilteredResponse<Job>}) {
    }
}

export class SetSearchTermFailAction implements Action {
    readonly type = SET_SEARCH_TERM_FAIL;

    constructor(public payload: {error: Error | Response}) {
    }
}

export declare type Actions
    = CacheToPageAction
    | CacheToPageSuccessAction
    | InitialiseAction
    | SetMode
    | SetSearchTermAction
    | SetSearchTermSuccessAction
    | SetSearchTermFailAction;



// WEBPACK FOOTER //
// ./src/app/pages/job-list-page/job-list-page.actions.ts